import { AnnotationPlane } from '~/domain/annotation/annotation';
import { PointMm } from '~/domain/geometry/patientGeometry';
import { LandmarkPoint } from '~/domain/landmark/landmark';
import { ShownPaneImage } from '~/engine/view/paneImage';
import { PlaneView } from '~/engine/view/views/PlaneView';
import { AnnotationPlacementTool } from './AnnotationPlacementTool';

export class LandmarkTool extends AnnotationPlacementTool {
    public toolType = 'landmark';

    private readonly _onPlace: (point: LandmarkPoint) => void;

    constructor(onPlace: (point: LandmarkPoint) => void) {
        super();
        this._onPlace = onPlace;
    }

    protected override startPlacement(
        _view: PlaneView,
        plane: AnnotationPlane,
        pointMm: PointMm,
        pane: ShownPaneImage
    ): boolean {
        // In the shown image's own frame: a click on a pane showing the moving scan is a moving-frame point.
        this._onPlace({
            pointMm: pane.toImageFrame(pointMm),
            plane: pane.planeToImageFrame(plane),
            frameOfReferenceUid: pane.image.parent.frameOfReferenceUid,
        });
        this.finishPlacement();
        return true;
    }

    protected override placePoint(): void {}

    protected override moveCursor(): void {}

    protected override undoPoint(): void {}

    protected override lastPlacedPoint(): PointMm | null {
        return null;
    }

    protected override discardDraft(): void {}
}
